import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, ReferenceLine, Cell } from "recharts";

const short = (a) => (a || "").split(",")[0].slice(0, 22);

/* 结构分包商效率：按项目 SLA 天数 vs 实际工作日（逾期红色）+ KPI 条 */
export const StructEfficiencyChart = ({ eff, zh = true, compact = false }) => {
  const T = (z, e) => (zh ? z : e);
  if (!eff) return null;
  const rows = (eff.rows || eff.projects || []).map((r) => ({ ...r, label: short(r.address), actual: r.actualWorkDays ?? (r.status && !r.deliveredAt && r.overdueDays ? (r.slaDays || 0) + r.overdueDays : null), pending: !r.deliveredAt && r.actualWorkDays == null }));
  const kpi = [
    [T("准时率", "On-time"), eff.onTimeRate == null ? "—" : `${eff.onTimeRate}%`, eff.onTimeRate == null ? "text-slate-700" : eff.onTimeRate >= 80 ? "text-emerald-700" : "text-red-600"],
    [T("平均响应", "Avg response"), eff.avgResponseHours == null ? "—" : `${eff.avgResponseHours}h`, "text-slate-700"],
    [T("平均完成", "Avg work days"), eff.avgWorkDays == null ? "—" : T(`${eff.avgWorkDays} 工作日`, `${eff.avgWorkDays} wd`), "text-slate-700"],
    [T("累计逾期", "Overdue days"), `${eff.totalOverdueDays || 0}`, (eff.totalOverdueDays || 0) > 0 ? "text-red-600" : "text-emerald-700"],
    [T("项目数 / 已交付", "Orders / delivered"), `${eff.count || 0} / ${eff.delivered || 0}`, "text-slate-700"],
  ];
  return (
    <div data-testid="struct-eff-chart" className="space-y-2">
      <div className={`grid ${compact ? "grid-cols-5" : "grid-cols-2 sm:grid-cols-5"} gap-2`}>
        {kpi.map(([l, v, c]) => <div key={l} className="rounded-lg bg-slate-50 border border-slate-100 px-2 py-1.5"><p className="text-[10px] text-slate-400">{l}</p><p className={`text-sm font-extrabold ${c}`}>{v}</p></div>)}
      </div>
      {rows.length === 0 ? <p className="text-xs text-slate-400 py-3 text-center" data-testid="struct-eff-empty">{T("暂无已发包项目", "No orders yet")}</p> : (
        <div style={{ height: compact ? 160 : 220 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows} margin={{ top: 4, right: 8, left: -16, bottom: 0 }} barGap={2}>
              <XAxis dataKey="label" tick={{ fontSize: 10 }} interval={0} angle={rows.length > 6 ? -20 : 0} height={rows.length > 6 ? 46 : 24} />
              <YAxis tick={{ fontSize: 10 }} allowDecimals={false} />
              <Tooltip formatter={(v, n) => [v, n === "slaDays" ? T("SLA 工作日", "SLA days") : T("实际工作日", "Actual days")]} labelFormatter={(l, p) => p?.[0]?.payload?.address || l} />
              <Legend formatter={(v) => (v === "slaDays" ? T("SLA 工作日", "SLA") : T("实际工作日（红=逾期）", "Actual (red = late)"))} wrapperStyle={{ fontSize: 10 }} />
              <ReferenceLine y={5} stroke="#94a3b8" strokeDasharray="3 3" />
              <Bar dataKey="slaDays" fill="#cbd5e1" radius={[3, 3, 0, 0]} />
              <Bar dataKey="actual" radius={[3, 3, 0, 0]}>
                {rows.map((r, i) => <Cell key={i} fill={r.pending ? "#f59e0b" : r.onTime === false || (r.overdueDays || 0) > 0 ? "#ef4444" : "#10b981"} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>)}
    </div>
  );
};
